import script from "./AIChatWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./AIChatWidget.vue?vue&type=script&setup=true&lang=js"

import "./AIChatWidget.vue?vue&type=style&index=0&id=e973853a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e973853a"]])

export default __exports__